import React, {useMemo} from "react";
import {CircularProgress, IconButton, TextField} from "@mui/material";
import {FilterAlt, SearchOutlined} from "@mui/icons-material";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";

interface SearchTextFieldProps extends React.ComponentProps<typeof TextField> {
    SearchIcon?: React.ReactNode;
    onSearch: () => void;
    openFilters?: () => void;
    pageProps?: { pagination: IPagination, setPagination?: (pagination: IPagination) => void }
    hasChanges?: boolean;
}

export function SearchTextField(props: SearchTextFieldProps) {
    const {SearchIcon, openFilters, onSearch, pageProps, hasChanges, ...rest} = props;

    const defaultFilterButton = useMemo(() => {
        return (
            <IconButton disabled={openFilters == null} onClick={openFilters}
                        color={hasChanges ? 'primary' : undefined}>
                <FilterAlt/>
            </IconButton>)
    }, [openFilters])

    const defaultSearchBt = useMemo(() => {
        return <IconButton onClick={() => {
            if (onSearch != null)
                onSearch()
        }} disabled={pageProps?.pagination.loading || props.disabled == true}>
            {pageProps?.pagination.loading && <CircularProgress size={24}/> ||
                <SearchOutlined/>}
        </IconButton>
    }, [rest.value, pageProps]);


    return <TextField {...rest}
                      size={rest.size}
                      onKeyDown={(e) => {
                          if (e.key == 'Enter') {
                              if (onSearch != null)
                                  onSearch();
                          }
                      }}
                      slotProps={{
                          ...rest.slotProps,
                          input: {
                              ...rest.slotProps?.input,
                              endAdornment: <>{defaultFilterButton}{SearchIcon != null ? SearchIcon : defaultSearchBt}</>,
                          }
                      }}/>;
}